import { HoverCard, Pill } from '@mantine/core';
// utils
import { TUTM } from '@/pages/Sessions/Sessions.types.ts';

interface UTMsProps {
    value: string;
}

const UTMs = ({ value }: UTMsProps) => {
    let utms: TUTM[] = [];
    if (value) {
        try {
            const parsed = JSON.parse(value) as TUTM[];
            utms = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.log(error);
            utms = [];
        }
    }

    if (utms.length === 0) {
        return <>&ndash;</>;
    }

    return (
        <HoverCard withArrow shadow="md" width={280}>
            <HoverCard.Target>
                <div className="cursor-pointer">
                    {utms.map((utm) => (
                        <Pill key={utm.name} size="xs">
                            {utm.value}
                        </Pill>
                    ))}
                </div>
            </HoverCard.Target>
            <HoverCard.Dropdown>
                <div className="text-xs">
                    {utms.map((utm) => (
                        <div key={utm.name}>
                            <strong>{utm.name}:</strong> {utm.value}
                        </div>
                    ))}
                </div>
            </HoverCard.Dropdown>
        </HoverCard>
    );
};

export default UTMs;
